<template>
  <b-form-group>
    <b-form-input v-if="disabled" disabled :value="displayValue || value"/>
    <b-form-input v-else v-model="searchQuery.value" v-validate="{ required: true }" @focus="showDropdown = true" @input="filterOptions" @keydown.down.prevent="moveDown"
        @keydown.up.prevent="moveUp" @keydown.enter.prevent="selectHighlighted" @keydown.esc="showDropdown = false" @keydown.tab="showDropdown = false" placeholder="Select an option"
        autocomplete="off" aria-haspopup="listbox" :aria-expanded="showDropdown ? 'true' : 'false'" aria-controls="dropdown-list"/>
    <small v-if="errorMsg" class="text-danger text-small mt-3">{{ errorMsg }}</small>

    <b-list-group v-show="showDropdown && filteredOptions.length" id="dropdown-list" role="listbox" aria-label="Selectable options" class="position-absolute w-100 z-index-100"
                  style="max-height: 200px; overflow-y: auto;">
      <b-list-group-item v-for="(option, index) in filteredOptions" :key="`${option.value}-${index}`" role="option" :aria-selected="index === highlightedIndex ? 'true' : 'false'"
                         button @click="selectOption(option)" :class="{ active: index === highlightedIndex }" @mouseover="highlightedIndex = index">
        {{ option.code }} ({{ option.text }})
      </b-list-group-item>
    </b-list-group>
  </b-form-group>
</template>

<script>

export default {
  props: ['disabled', 'value', 'errorMsg', 'displayValue','pf'],
  data() {
    return {
      employees: [],
      options: [],
      searchQuery: { value: '', text: '' },
      filteredOptions: [],
      showDropdown: false,
      highlightedIndex: -1,
      _reqTimer: null,
    };
  },
  watch: {
    searchQuery: {
      handler(newVal, oldVal) {
        if (newVal?.text !== oldVal?.text) this.filterOptions();
      },
      deep: true,
    },
    showDropdown(isVisible) {
      if (!isVisible) this.highlightedIndex = -1;
    },
  },
  methods: {
    filterOptions() {
      const query = (this.searchQuery.value || '').trim().toLowerCase();

      clearTimeout(this._reqTimer);
      this._reqTimer = setTimeout(() => {
        this.getUserEmployees(query);
      }, 200);

      // this.filteredOptions = this.options.filter(o =>
      //     (o.value + ' ' + o.text).toLowerCase().includes(query)
      // );
      this.filteredOptions = this.options.filter(option =>
        `${option.code} ${option.text}`
          .toLowerCase()
          .includes(query)
      );
      this.highlightedIndex = this.filteredOptions.length ? 0 : -1;
    },

    getUserEmployees(query) {

      axios.get(this.$api_url + '/bot/user/list/system', { params: { employee_code: query,pf:this.pf } }).then((response) => {
        const data = response.data;
        const next = data.map(e => ({
            text: e.name ?? '',
            code: e.employee_code ?? '',
            value: e.employee_id ?? '',
        }));

        const seen = new Set();
        this.options = next.filter(o => {
          if (!o.value || seen.has(o.value)) return false;
          seen.add(o.value);
          return true;
        });

        // const q = (this.searchQuery.value || '').trim().toLowerCase();
        // this.filteredOptions = this.options.filter(o =>
        //     (o.value + ' ' + o.text).toLowerCase().includes(q)
        // );
        const q = (this.searchQuery.value || '').trim().toLowerCase();

        this.filteredOptions = this.options.filter(option =>
          `${option.code} ${option.text}`
            .toLowerCase()
            .includes(q)
        );

        this.highlightedIndex = this.filteredOptions.length ? 0 : -1;
      }).catch(e => {
        this.serverError(e);
        this.options = [];
        this.filteredOptions = [];
        this.highlightedIndex = -1;
      })
    },

    // selectOption(option) {
    //   this.searchQuery = { ...option };
    //   this.showDropdown = false;
    //   this.$emit('input', option.value);
    //   this.$emit('change', option.value);
    // },

    selectOption(option) {
      this.searchQuery = {
        value: option.code,
        text: option.text,
      };

      this.showDropdown = false;

      // employee_id is passed to the parent/backend
      this.$emit('input', option.value);
      this.$emit('change', option.value);
    },

    moveDown() {
      if (this.highlightedIndex < this.filteredOptions.length - 1) {
        this.highlightedIndex++;
        this.scrollToHighlighted();
      }
    },
    moveUp() {
      if (this.highlightedIndex > 0) {
        this.highlightedIndex--;
        this.scrollToHighlighted();
      }
    },
    selectHighlighted() {
      const selected = this.filteredOptions[this.highlightedIndex];
      if (selected) this.selectOption(selected);
    },
    scrollToHighlighted() {
      this.$nextTick(() => {
        const items = this.$el.querySelectorAll('.list-group-item');
        if (items[this.highlightedIndex]) {
          items[this.highlightedIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    },
    handleClickOutside(e) {
      if (!this.$el.contains(e.target)) this.showDropdown = false;
    },
  },
  mounted() {
    this.filteredOptions = [];
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
    clearTimeout(this._reqTimer);
  },
};
</script>

<style scoped>
.z-index-100 { z-index: 1000; }
.b-list-group-item.active {
  background-color: #01524b;
  color: #fff;
}
</style>
